import * as React from 'react';
import classnames from 'classnames';
import isNil from 'lodash/isNil';

import InstagramDataEnabledBadge from 'components/instagram-data-enabled/badge/InstagramDataEnabledBadge';

import { __t, applyTranslations } from 'utils/language';

import './instagram-data-enabled.scss';

applyTranslations(require('./instagram-data-enabled.i18n.json'));

interface OwnProps {
  hasActiveFbConnection: boolean,
  influencerCheckOverride?: boolean,
  header?: {
    show: boolean,
    text?: string
  },
  defaultText?: {
    show: boolean,
    text?: string
  },
  additionalText?: {
    text?: string,
    hasUnderline?: boolean
  },
  contextMenu?: React.ReactNode,
  flex?: 'row' | 'column'
}

const InstagramDataEnabled = ({
  hasActiveFbConnection,
  influencerCheckOverride,
  header,
  defaultText,
  additionalText,
  contextMenu,
  flex = 'column'
}: OwnProps): JSX.Element => {
  const containerClasses = classnames('instagram-data-enabled', {
    [`instagram-data-enabled--flex-${flex}`]: Boolean(flex)
  });

  const badgeClasses = classnames('instagram-data-enabled__badge', {
    [`instagram-data-enabled__badge--flex-${flex}`]: Boolean(flex)
  });

  return (
    <div className={containerClasses}>
      <div className="instagram-data-enabled__content">
        {
          header?.show && (
            <div className="instagram-data-enabled__header">
              {header.text || __t('instagram_data_enabled.header')}
            </div>
          )
        }
        {
          defaultText?.show && (
            <div className="instagram-data-enabled__text">
              {defaultText.text || __t('instagram_data_enabled.text')}
            </div>
          )
        }
        {
          !isNil(additionalText?.text) && (
            <div
              className="instagram-data-enabled__text instagram-data-enabled__additional-text"
              {...(!isNil(additionalText?.hasUnderline) ? { style: { textDecoration: 'underline' } } : null)}
            >
              {additionalText?.text}
            </div>
          )
        }
      </div>
      <div className={badgeClasses}>
        <InstagramDataEnabledBadge
          hasActiveFbConnection={hasActiveFbConnection}
          influencerCheckOverride={influencerCheckOverride}
        />
        {contextMenu}
      </div>
    </div>
  );
};

export default InstagramDataEnabled;
